module.exports = __webpack_public_path__ + "img/logo-cotizacion.08319571.png";